// extracted by mini-css-extract-plugin
module.exports = {"table":"BlogPost_table__Bkb7H","cont":"BlogPost_cont__wk24z","post":"BlogPost_post__wv2Ol","right":"BlogPost_right__kr7PG"};